import { useSession } from "@supabase/auth-helpers-react";
import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import useUserDetails from "../../hooks/useUserDetails";
import InviteClaimBox from "../invite-claim-box";
import MainChatInput from "../main-chat-input";
import MobileAppBanner from "../mobile-app-banner";
import Breadcrumbs from "../shared/breadcrumbs";
import AppShell from "./app-shell";

/**
 * Application layout with a persistent left navigation on desktop
 * and a collapsible drawer on smaller screens.
 */
export function AppLayout() {
  const session = useSession();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const isAuthenticated = Boolean(session);
  const location = useLocation();
  const authPaths = ["/login", "/signup"];
  const isHomeAuthView = !session && location.pathname === "/";
  const isFullWidthAuthView =
    authPaths.includes(location.pathname) || isHomeAuthView;
  const { userDetails } = useUserDetails();
  const isAdmin = userDetails?.type === "admin";

  return (
    <div className="min-h-screen bg-cream">
      <MobileAppBanner />
      <AppShell
        isAuthenticated={isAuthenticated}
        isMobileNavOpen={isMobileNavOpen}
        onOpenMobileNav={() => setIsMobileNavOpen(true)}
        onCloseMobileNav={() => setIsMobileNavOpen(false)}
        isAdmin={Boolean(isAdmin)}
      >
        <div
          className={
            isFullWidthAuthView
              ? "w-full"
              : "mx-auto w-full max-w-7xl space-y-6 px-4 sm:px-6 lg:px-8"
          }
        >
          {session && <Breadcrumbs />}
          <Outlet />
        </div>
      </AppShell>

      {session && <MainChatInput />}
      <InviteClaimBox />
    </div>
  );
}

export default AppLayout;
